
$('.js-slider').slick({
 	dots: true,
 	respondTo: 'slider',
    adaptiveHeight: true,
 	prevArrow: '<button class="slider__button slider__button--prev"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',
    nextArrow: '<button class="slider__button slider__button--next"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>'
});

$('.js-slider-reviews').slick({
 	dots: true,
 	prevArrow: '<button class="slider__button slider__button--prev"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',
    nextArrow: '<button class="slider__button slider__button--next"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',

});

$('.js-slider-catalog').slick({
	slidesToShow: 3,
	slidesToScroll: 3,
	infinite: false,
	adaptiveHeight: false,
 	dots: true,
 	prevArrow: '<button class="slider__button slider__button--prev"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',
    nextArrow: '<button class="slider__button slider__button--next"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',
    responsive: [
	    {
      		breakpoint: 1024,
	      	settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2,
		        infinite: false
         	}
    	},
    	{
      		breakpoint: 767,
	      	settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        infinite: false,
		        dots: false
         	}
    	}
    ] 
});

if ($(window).width() < 768) {
	var catalogSlick = $('.js-slider-catalog');

	$(window).on('load', function(){
		$('.slider__nav').html((catalogSlick.slick("getSlick").currentSlide + 1) + '/' +  catalogSlick.slick("getSlick").slideCount);
	})

	catalogSlick.on('afterChange', function(event, slick, currentSlide, nextSlide) {
		$('.slider__nav').html(($(this).slick("getSlick").currentSlide + 1) + '/' +  $(this).slick("getSlick").slideCount);	      
	});
}




$(window).on('load', function() {

    if ($(window).width() < 1025 && $(window).width() > 767) {
		
		$('.slider-only-tablet').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
		 	dots: true,
		 	infinity: false,
		 	prevArrow: '<button class="slider__button slider__button--prev"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>',
		    nextArrow: '<button class="slider__button slider__button--next"><svg class="icon" width="33px" height="12px"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-small"></use></svg></button>'
		})
    }

    if ($(window).width() < 768) {

    	$('.slider-only-mobl').slick({
		 	dots: false,
		 	infinity: false,
		 	arrows: false,
		 	centerMode: true
		});
    } 
}); 
